import { render, staticRenderFns } from "./ResourceModal.vue?vue&type=template&id=b6f4d062&"
import script from "./ResourceModal.vue?vue&type=script&lang=js&"
export * from "./ResourceModal.vue?vue&type=script&lang=js&"
import style0 from "./ResourceModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports